import styled from 'styled-components';

export const LinkItem = styled.span`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.secondaryColor[500]};

    .MuiTypography-root {
        font-weight: 500;
        font-size: 12px;
      }

    & .active {
      border-bottom: 3px solid ${({ theme }) => theme.primary.navBar};
      // color: ${({ theme }) => theme.primary.navBar};
      color: #242424;
      .MuiTypography-root {
        font-weight: 700;
        // font-size: 16px;
      }
    }

    a {
      margin:  0.5rem;
      padding: 0.5rem;
      text-align: center;
      border-bottom: 3px solid transparent;
      // border-bottom: 1.5px solid ${({ theme }) => theme.secondaryColor[500]};
      color: ${({ theme }) => theme.secondaryColor[700]};
      text-decoration: none;

      &:not(.active):hover {
        border-bottom: 3px solid ${({ theme }) => theme.secondaryColor[300]};
      }
    }
  }
`;
